import React, { useRef, useEffect, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import Paper from '@mui/material/Paper';
import Fab from '@mui/material/Fab';
import NavigationIcon from '@mui/icons-material/Navigation';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation, useNavigate } from 'react-router-dom';
import { mailSend } from './api';

function RichTextEditor() {
    const location = useLocation();
    const navigate = useNavigate();
    const { originalContent, userId, receivedUserId, originalTitle } = location.state || {};
    const editorRef = useRef(null);
    const [content, setContent] = useState('');
    const [title, setTitle] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const quill = new Quill(editorRef.current, {
            theme: 'snow',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    ['link', 'image'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                ],
            },
        });

        if (originalContent) {
            setTimeout(() => {
                const quotedContent = `<blockquote style="border-left: 4px solid #ddd; margin: 10px 0; padding-left: 10px; color: #555;">${originalContent}</blockquote>`;
                quill.clipboard.dangerouslyPasteHTML(quotedContent);
            }, 0);
        }

        if (originalTitle) {
            setTitle(`回复: ${originalTitle}`);
        }

        quill.on('text-change', () => {
            setContent(quill.root.innerHTML);
        });
    }, [originalContent, originalTitle]);

    const sendToServer = async () => {
        const req = {
            content: content,
            title: title,
            sendUserId: userId,
            receivedUserId: receivedUserId
        };
        try {
            await mailSend(req);
            setOpenSnackbar(true);
            setTimeout(() => {
                navigate('/sharedNote');
            }, 3000);
        } catch (error) {
            console.error('发送失败:', error);
        }
    };

    return (
        <Paper square sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: 2 }}>
            <TextField
                label="标题"
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ marginBottom: 2 }}
            />
            <div ref={editorRef} style={{ flex: 1, minHeight: '200px' }} />
            <Fab
                variant="extended"
                color="secondary"
                aria-label="edit"
                sx={{ position: 'absolute', bottom: 20, right: 16 }}
                onClick={sendToServer}
            >
                发送
                <NavigationIcon />
            </Fab>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
            >
                <Alert severity="success" sx={{ width: '100%' }}>
                    发送成功！即将返回首页...
                </Alert>
            </Snackbar>
        </Paper>
    );
}

export default RichTextEditor;